<template>
  <div id="form-creation-options-input">
    <Input
      v-for="(option, index) in input.optionQuantity"
      :key="index"
      class="scs-input"
      :heading="`Option ${index + 1}:`"
      :placeholder="`Option ${index + 1}:`"
      @scs-input="optionInput($event, index)"
    />
  </div>
</template>
<script>
import Input from "@/Components/Elements/Input.vue";
export default {
  methods: {
    optionInput($event, index) {
      this.$emit("option-input", { value: $event, index: index });
    },
  },
  components: {
    Input,
  },
  props: ["input"],
};
</script>
<style scoped>
@media screen {
  #form-creation-options-input {
    min-height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
  }

  .scs-input {
    width: 100%;
    margin: 10px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
@media screen {
  @media (min-width: 800px) {
  }
}
</style>
